export default "__VITE_ASSET__SEt7ZinK__"